// React Query обвивките за разнасянето, добавени с редизайна. Инвалидацията
// минава през `invalidateAll` (useInventory.ts) — единственото място.
import { useMutation, useQueries, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  annulReportPosting,
  getPostedReports,
  type DocumentStatusFilter,
} from "../api/inventoryPostings";
import {
  getReportPostingPreview,
  type ReportPostingsParams,
} from "../api/inventory";
import { invalidateAll } from "./useInventory";

export const usePostedReports = (
  params: (ReportPostingsParams & { status?: DocumentStatusFilter }) | null,
) =>
  useQuery({
    queryKey: ["inventory", "report-postings", "posted", params],
    queryFn: () => getPostedReports(params!),
    enabled: !!params,
  });

export const useAnnulReportPosting = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, reason }: { id: number; reason: string | null }) =>
      annulReportPosting(id, reason),
    onSuccess: () => invalidateAll(qc),
  });
};

// Прегледите на няколко чакащи отчета наведнъж — за статуса в списъка
// („2 продукта с недостиг"). Същият ключ като useReportPostingPreview, така че
// избраният отчет не се зарежда втори път.
export const usePendingPreviews = (reportIds: number[]) =>
  useQueries({
    queries: reportIds.map((reportId) => ({
      queryKey: ["inventory", "report-posting-preview", reportId],
      queryFn: () => getReportPostingPreview(reportId),
      staleTime: 60_000,
    })),
  });
